module.exports = __webpack_public_path__ + "static/media/SearchPageIconColored.59d1ce0b.svg";